import api from '../api.js';

// Environment is loaded asynchronously from server env API. This returns a
// Promise which resolves to an object containing the env variables.
export default api.get('/api/env');
